import {getDefaultVideoPlaybackSettings} from 'powtoon-commons/models/utils/videoPlaybackSettings'

export default function videoItem(libraryItem, {startTime = 0, endTime = 2}) {
  return {
    playbackSettings: libraryItem.playbackSettings || getDefaultVideoPlaybackSettings(libraryItem, startTime, endTime)
  }
}
